export async function openModal({url, modalClass}) {
  const node = document.createElement("div");
  node.dataset.controller = "common--modal";
  node.dataset.modalContentUrl = url;
  node.classList = ["modal"];
  node.innerHTML = `
    <div class="modal-dialog ${modalClass}">
      <div class="modal-content">
      </div>
    </div>
  `;
  document.body.append(node);
}
